import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'
import { StoreContext } from 'store/context'
import TeamsUpdateComponent from './component'

export const TeamsUpdate = combine({
  hooks: [
    withContext(
      'adminTeamsService',
      ServicesContext,
      ({ adminTeamsService }) => adminTeamsService
    ),
    withContext('appStore', StoreContext),

    withCallbacks(
      {
        getTeamInfoById:
          ({ adminTeamsService }) =>
          (teamId) => {
            const content = adminTeamsService.getTeamById(teamId)
            return content
          },
        onSubmit:
          ({ adminTeamsService }, { history }) =>
          async (teamDTO) => {
            await adminTeamsService.updateTeam(teamDTO)
            toaster.info('Team has been successfully updated')
            history.push(admin.teams())
          },
      },
      []
    ),
  ],
  transformProps: ({ match, getTeamInfoById, onSubmit }) => {
    return {
      teamId: Number(match.params.teamId),
      getTeamInfoById,
      onSubmit,
    }
  },
})(TeamsUpdateComponent)
